import { Button, styled } from '@mui/material'
import { Icon } from 'packages/eid-icons'

const StyledButton = styled(Button)((props) => ({
    textTransform: 'capitalize',
    fontSize: '14px',
    height: '40px !important',
    color: '#ffffff !important',
    backgroundColor: '#0057A0 !important',
    border: '1px solid #ffffff',
    margin: 0,
    boxShadow: 'none',
    minWidth: '65px !important',
    borderRadius: '4px !important',
    padding: '8px 12px',

    '&:hover': {
        color: '#0057A0 !important',
        backgroundColor: '#ffffff !important',
        borderColor: '#0057A0 !important',
    },
    ...props.styles,
}))

const NewDelegationButton = ({ color, styles, children, ...rest }) => {
    return (
        <StyledButton size="small" {...rest} startIcon={<Icon name="Plus" />}>
            {children}
        </StyledButton>
    )
}

export default NewDelegationButton
